import React from 'react';
import Button from './Button';
import VehicleCard from './VehicleCard';
import vehicles from './vehicles';
import heroImage from './img/tesla.jpeg';
import './Home.css';

const TRUST_ITEMS = ['Fully insured', 'Columbus host pickup', 'Flexible terms'];

const STEPS = [
  { title: 'Browse the fleet', body: 'See what is available now and what is coming soon.' },
  { title: 'Request to reserve', body: 'Tell us your dates and we will confirm availability.' },
  { title: 'Pick up and drive', body: 'Meet in Columbus and hit the road.' },
];

function Home() {
  return (
    <>
      <section className="home-hero">
        <div className="home-hero__copy">
          <h1>Premium EVs and luxury SUVs, ready to drive in Columbus</h1>
          <p>
            Rent Columbus's newest Tesla and Volvo fleet: verified, insured, and ready for pickup.
          </p>
          <div className="home-hero__ctas">
            <Button variant="primary" to="/fleet">
              View Fleet
            </Button>
            <Button variant="secondary" to="/fleet">
              Reserve a Vehicle
            </Button>
          </div>
        </div>
        <img className="home-hero__image" src={heroImage} alt="Tesla Model X" />
      </section>

      <section className="home-trust" aria-label="Why rent with us">
        {TRUST_ITEMS.map((item) => (
          <span key={item} className="home-trust__item">
            {item}
          </span>
        ))}
      </section>

      <section className="home-fleet">
        <h2>Our Fleet</h2>
        <div className="home-fleet__grid">
          {vehicles.map((vehicle) => (
            <VehicleCard
              key={vehicle.slug}
              name={vehicle.name}
              year={vehicle.year}
              imageSrc={vehicle.images[0]}
              imageAlt={vehicle.imageAlt}
              status={vehicle.status}
              price={vehicle.price || 'Contact for pricing'}
              to={`/fleet/${vehicle.slug}`}
            />
          ))}
        </div>
      </section>

      <section className="home-steps">
        <h2>How It Works</h2>
        <ol className="home-steps__list">
          {STEPS.map((step, index) => (
            <li key={step.title} className="home-steps__item">
              <span className="home-steps__number">{index + 1}</span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>

      <section className="home-cta-banner">
        <p>Have a car in mind? Reserve it online.</p>
        <Button variant="primary" to="/fleet">
          Reserve a Vehicle
        </Button>
      </section>
    </>
  );
}

export default Home;
